import { AccountTree, AccountTreeFilled, DataTable, DataTableFilled, Mail, MailFilled, Calculate, CalculateFilled, BugReport, BugReportFilled, Report, } from '@interhyp/platform-icons';
import { ConsumerCreditContext, MortgageContext } from './contexts';
import { createNavigation } from './functions/createNavigation';
import { ConsumerCreditCommunicationRoute, ConsumerCreditFinancingRoute, ConsumerCreditLogbookRoute, ConsumerCreditOfferRoute, ConsumerCreditOverviewRoute, } from './routes/consumerCredit';
import { EhypBrokerWorkplaceLightRoute } from './routes/external';
import { CalculatorsRoute, CommunicationRoute, DashboardRoute, IssueTrackerRoute, ReportingRoute, } from './routes/general';
import { MortgageCommunicationRoute, MortgageDocumentsRoute, MortgageFinancingRoute, MortgageIntentRoute, MortgageLogbookRoute, MortgageOfferRoute, MortgagePreInquiryRoute, } from './routes/mortgage';
import { OrganizationRootRoute } from './routes/organization';
export const MainNavigation = createNavigation('main', {
    links: [
        {
            route: DashboardRoute,
            label: 'Dashboard',
            icon: DataTable,
            activeIcon: DataTableFilled,
        },
        {
            route: CommunicationRoute,
            label: 'Postfach',
            icon: Mail,
            activeIcon: MailFilled,
        },
        {
            route: CalculatorsRoute,
            label: 'Rechner',
            icon: Calculate,
            activeIcon: CalculateFilled,
        },
        {
            route: ReportingRoute,
            label: 'Reportings',
            icon: Report,
        },
        {
            route: IssueTrackerRoute,
            label: 'Tickets',
            icon: BugReport,
            activeIcon: BugReportFilled,
        },
        {
            route: OrganizationRootRoute,
            label: 'Organisation',
            icon: AccountTree,
            activeIcon: AccountTreeFilled,
        },
        {
            externalRoute: EhypBrokerWorkplaceLightRoute,
        },
    ],
});
export const MortgageContextNavigation = createNavigation('mortgage', {
    links: [
        {
            route: MortgageIntentRoute,
            label: 'Vorhaben',
        },
        {
            route: MortgageFinancingRoute,
            label: 'Finanzierung',
        },
        {
            route: MortgagePreInquiryRoute,
            label: 'Voranfrage',
        },
        {
            route: MortgageOfferRoute,
            label: 'Angebote',
        },
        {
            route: MortgageDocumentsRoute,
            label: 'Unterlagen',
        },
        {
            route: MortgageLogbookRoute,
            label: 'Logbuch',
        },
        {
            route: MortgageCommunicationRoute,
            label: 'Kommunikation',
        },
        // {
        //   route: MortgageConfigurationRoute,
        //   label: 'Einstellungen',
        // },
    ],
    context: MortgageContext,
});
export const ConsumerCreditContextNavigation = createNavigation('consumer-credit', {
    links: [
        {
            route: ConsumerCreditOverviewRoute,
            label: 'Übersicht',
        },
        {
            route: ConsumerCreditFinancingRoute,
            label: 'Finanzierung',
        },
        {
            route: ConsumerCreditOfferRoute,
            label: 'Angebote',
        },
        {
            route: ConsumerCreditLogbookRoute,
            label: 'Logbuch',
        },
        {
            route: ConsumerCreditCommunicationRoute,
            label: 'Kommunikation',
        },
    ],
    context: ConsumerCreditContext,
});
export const getContextNavigations = () => ({
    [MortgageContext.id]: MortgageContextNavigation,
    [ConsumerCreditContext.id]: ConsumerCreditContextNavigation,
});
